<template>
	<div class="registration-form-container">
		<div class="registration-form-title">
			<button @click="redirectTo('/', 'stretch')"><img src="@/common/assets/images/icon-left.webp" alt="back">
			</button>
			<h2>Request a Guest Account</h2>
		</div>
		<form class="registration-form" @submit="(event) => handleSubmit(event)">

			<div class="register-form-content">
				<label for="email">Email:</label>
				<input
					type="email"
					id="email"
					name="email"
					placeholder="Enter your email"
					required
					autocomplete="email"
					v-model="formData.username"
					@focusout="FORM_VALIDATOR?.validateFormField('username')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('username')}]"
				>
			</div>

			<div class="register-form-content">
				<label for="fullName">Full Name:</label>
				<input
					type="text"
					id="fullName"
					name="fullName"
					placeholder="Enter your full name"
					required
					autocomplete="fullName"
					v-model="formData.fullName"
					@focusout="FORM_VALIDATOR?.validateFormField('fullName')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('fullName')}]"
				>
			</div>

			<div class="register-form-content">
				<label for="password">Password:</label>
				<input
					type="password"
					id="password"
					name="password"
					placeholder="Enter your password"
					required
					autocomplete="password"
					v-model="formData.password"
					@focusout="FORM_VALIDATOR?.validateFormField('password')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('password')}]"
				>
				<span class="toggle-password" @click="togglePasswordVisibility('password')">
					<img :src="visible" alt="eye">
				</span>
			</div>

			<div class="register-form-content">
				<label for="confirmPassword">Confirm Password:</label>
				<input
					type="password"
					id="confirmPassword"
					name="confirmPassword"
					placeholder="Confirm your password"
					required
					autocomplete="confirmPassword"
					v-model="formData.confirmPassword"
					@focusout="FORM_VALIDATOR?.validateFormField('confirmPassword')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('confirmPassword')}]"
				>
				<span class="toggle-password" @click="togglePasswordVisibility('confirmPassword')">
					<img :src="visible" alt="eye">
				</span>
			</div>

			<div class="register-form-content">
				<label for="company">Company:</label>
				<input
					type="text"
					id="company"
					name="company"
					placeholder="Enter your company name"
					required
					autocomplete="company"
					v-model="formData.company"
					@focusout="FORM_VALIDATOR?.validateFormField('company')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('company')}]"
				>
			</div>

			<div class="register-form-content">
				<label for="jobTitle">Job Title:</label>
				<input
					type="text"
					id="jobTitle"
					name="jobTitle"
					placeholder="Enter your job title"
					required
					autocomplete="jobTitle"
					v-model="formData.jobTitle"
					@focusout="FORM_VALIDATOR?.validateFormField('jobTitle')"
					:class="[{'error-border' : !FORM_VALIDATOR?.isFieldValid('jobTitle')}]"
				>
			</div>

			<div class="form-bottom">
				<span class="error" v-for="(error, index) in FORM_VALIDATOR?.errors()" :key="index">{{ error.fieldCondition.message }}</span>
				<input
					:class="['apply-button', {'not-allowed' : !FORM_VALIDATOR?.isFormValid() || !this.allFieldsAreFilled()}]"
					type="submit"
					value="Apply"
				>
			</div>

		</form>
	</div>
</template>

<script>
import loginMixin from "@/common/mixins/login-mixin";
import {FormValidator} from "@/common/services/FormValidator";
import {setUser} from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";

export default {
	name: "RegisterForm",
	mixins: [loginMixin],
	data() {
		return {
			formData: {
				username: null,
				fullName: null,
				password: null,
				confirmPassword: null,
				company: null,
				jobTitle: null
			},
			fieldsConditions: {
				username: {
					isRequired: {
						value: true,
						message: "The email is required."
					},
					pattern: {
						value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
						message: "The email does not match the required format."
					}
				},
				fullName: {
					minLength: {
						value: 3,
						message: 'The full name must be at least 3 symbols'
					},
					maxLength: {
						value: 255,
						message: 'The full name must not be more than 255 symbols'
					}
				},
				password: {
					pattern: {
						value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?`~-]).{10,100}$/,
						message: 'The password must be between 10 and 100 symbols and must contain at least one uppercase, one lowercase, digit, and special character'
					}
				},
				confirmPassword: {
					pattern: {
						value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+[\]{};':"\\|,.<>/?`~-]).{10,100}$/,
						message: 'The confirm password must be between 10 and 100 symbols and must contain at least one uppercase, one lowercase, digit, and special character'
					},
					matchWith: {
						value: () => this.getPassword(),
						message: "The confirm password does not match with the password."
					}
				},
				company: {
					isRequired: {
						value: true,
						message: 'The company is required.'
					},
					maxLength: {
						value: 255,
						message: 'The company must not be more than 255 symbols'
					}
				},
				jobTitle: {
					minLength: {
						value: 2,
						message: 'The job title must be at least 2 symbols'
					},
					maxLength: {
						value: 255,
						message: 'The job title must not be more than 255 symbols'
					}
				}
			},
			FORM_VALIDATOR: null
		}
	},
	mounted() {
		this.FORM_VALIDATOR = new FormValidator(this.formData, this.fieldsConditions);
	},
	methods: {
		getPassword() {
			return this.formData?.password
		},
		allFieldsAreFilled() {
			return this.formData.username && this.formData.password && this.formData.confirmPassword
				&& this.formData.jobTitle  && this.formData.company  && this.formData.fullName
		},
		registerUser() {
			setUser(this.formData, 'CREATE')
				.then(() => {
					this.$router.push('/register/success')
				})
				.catch((error) => {
					if (error.message.includes("status code 400")) {
						this.showNotification(`${this.$t('notifications.emailExists')}`, NOTIFICATION_TYPE.ERROR)
					} else {
						this.showNotification(`${this.$t('notifications.error')}`, NOTIFICATION_TYPE.ERROR)
					}
				})
				.finally(() => this.$loader.hide())
		},
		handleSubmit(event) {
			event.preventDefault();
			this.FORM_VALIDATOR.validateFormFields();

			if (this.FORM_VALIDATOR.isFormValid() && this.allFieldsAreFilled()) {
				this.$loader.show({
					text: '',
					description: '',
					buttonText: null,
					isBlue: false,
					onCancel: () => {
					}
				});

				this.registerUser();
			}

		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/common/assets/css/_variables.scss';

.registration-form-container {
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;
	width: 80%;
	gap: 20px;
	padding-left: 6%;

	@media (max-width: $tablet) {
		width: 100%;
		max-width: 480px;
		height: unset;
		padding: 0;
		margin: unset;
		gap: 30px;
	}

	.registration-form-title {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		gap: 20px;
		max-width: 480px;
		width: 100%;
		min-width: 250px;

		@media (max-width: $mobile) {
			min-width: unset;
		}

		button {
			width: 40px;
			height: 40px;
			padding: 8px;
			gap: 8px;
			cursor: pointer;
			background-color: #001929;
			border: 1px solid transparent;
			border-radius: 4px;

			&:hover {
				border: 1px solid #EBEBF52E;
			}
		}

		h2 {
			margin: 0;
			font-family: Tiempos Headline, serif;
			font-size: 24px;
			font-weight: 500;
			line-height: 34px;
			letter-spacing: 0.360px;
			text-align: left;
		}
	}

	.registration-form {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 15px;

		.register-form-content {
			display: flex;
			flex-direction: column;
			gap: 2px;
			position: relative;

			label {
				font-family: Roboto, serif;
				font-size: 10px;
				font-weight: 400;
				line-height: 16px;
				text-align: left;
				color: #FCFCFE;
				text-transform: uppercase;
			}

			input {
				border: 2px solid #E5E5EA;
				gap: 12px;
				padding: 10px 35px 10px 12px;
				font-family: Roboto, serif;
				font-size: 15px;
				font-weight: 400;

				&:focus {
					border: 2px solid $color-hover-button;
					outline: none;
				}
			}

			.error-border {
				border: 2px solid rgba(201, 32, 40, 1);
			}

			.toggle-password {
				position: absolute;
				right: 10px;
				top: 50%;
				z-index: 2;
				cursor: pointer;

				img {
					height: 15px;
					width: 17px;

					&.visible {
						height: 17px;
						width: 16px;
					}
				}
			}
		}

		.form-bottom {
			display: flex;
			flex-direction: column;
			justify-content: center;

			.error {
				position: relative;
				color: red;
				font-size: 12px;
			}

			.apply-button {
				background-color: $color-hover-button;
				min-height: 48px;
				padding: 10px 18px;
				gap: 12px;
				font-family: Roboto, serif;
				font-size: 17px;
				font-weight: 400;
				line-height: 22px;
				text-align: center;
				cursor: pointer;
				margin-top: 20px;
				margin-bottom: 20px;
				text-transform: uppercase;
				border: none;

				&.not-allowed {
					cursor: not-allowed;
				}
			}
		}

	}

}
</style>
